import axios from 'axios';
import { Flex, Spinner, Text } from "../../../../components";
import React, { useState } from "react";
import styled from "styled-components";
import moment from '../../../../utils/MomentConst';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Modal, ModalButton, ModalContainer, TextArea } from "../../components";
import ReactTooltip from 'react-tooltip';

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg};
  margin-bottom: 5px;
`;

const Container = styled(Flex)`
  flex-direction: column;
  width: 100%;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
  background: #161930;
  border-radius: 5px;
  padding: 18px 24px;
  margin-bottom: 12px;
`;

const TruncateText = styled(Text.Body)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusText = styled(TruncateText)`
  --red: #FF5071;
  --orange: #FFB25C;
  --green: #60FFB0;
  color: var(--${props => props.color || 'green'});
`;

const License = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [licenseData, setLicenseData] = useState(data);
  const [renewalStatus, setRenewalStatus] = useState(false);
  const [discordData, setDiscordData] = useState(false);
  const [userLogs, setUserLogs] = useState(false);
  const [licenseLogs, setLicenseLogs] = useState(false);

  const revealModal = () => setModal(true);
  const hideModal = () => setModal(false);

  const openLicense = () => {

    if (!isOpen) {

      if (!renewalStatus) {

        setIsLoading(true);

        axios
          .get('/api/admin/licenses/get-license-extra-details?id=' + licenseData.id)
          .then(res => {
            if (res.data.renewalStatus) {
              setRenewalStatus(res.data.renewalStatus);
            } else {
              setRenewalStatus(null);
            }
            if (res.data.discord) {
              setDiscordData(res.data.discord);
            } else {
              setDiscordData(null);
            }
            if (res.data.userLogs) {
              setUserLogs(res.data.userLogs);
            } else {
              setUserLogs(null);
            }
            if (res.data.licenseLogs) {
              setLicenseLogs(res.data.licenseLogs);
            } else {
              setLicenseLogs(null);
            }
            setIsOpen(true);
            setIsLoading(false);
          })
          .catch(err => {
            console.error(err);
          });

      } else {
        setIsOpen(true);
      }


    } else {
      setIsOpen(false);
    }

  }

  const renderLicenseStatus = () => {

    switch (renewalStatus.flag) {
      case 'paid':
        return (
          <span style={{ color: '#60FFB0', fontWeight: 700 }}>
            {renewalStatus.flag.charAt(0).toUpperCase() + renewalStatus.flag.slice(1).replace('_', ' ')}
          </span>
        );
        break;
      case 'past_due':
        return (
          <span style={{ color: '#FF607D', fontWeight: 700 }} data-tip={`Retries ${renewalStatus.retriesCount}/5`} >
            {renewalStatus.flag.charAt(0).toUpperCase() + renewalStatus.flag.slice(1).replace('_', ' ')}
          </span>
        );
        break;
      case 'renewing_soon':
        return (
          <span style={{ color: '#FFCA59', fontWeight: 700 }} data-tip={`Charging in ${renewalStatus.hoursDifference} hours`}>
            {renewalStatus.flag.charAt(0).toUpperCase() + renewalStatus.flag.slice(1).replace('_', ' ')}
          </span>
        );
        break;
      default:
        return (
          <span style={{ color: '#FFCA59', fontWeight: 700 }}>
            {renewalStatus.flag.charAt(0).toUpperCase() + renewalStatus.flag.slice(1).replace('_', ' ')}
          </span>
        );
        break;
    }

  }

  const displayDiscordInfo = () => {

    if (discordData) {
      setModalHeader("Discord Info");
      setModalContent(JSON.stringify(discordData, undefined, 2));
      revealModal();
    } else {
      NotificationManager.error('Not Available', '');
    }

  }

  const displayUserLogs = () => {
    setModalHeader("User Logs");
    setModalContent(JSON.stringify(userLogs, undefined, 2));
    revealModal();
  }

  const displayLicenseLogs = () => {
    setModalHeader("License Logs");
    setModalContent(JSON.stringify(licenseLogs, undefined, 2));
    revealModal();
  }

  const cancelSubscription = () => {
    axios
      .put('/api/admin/licenses/cancel-license-renewal?licenseId=' + licenseData.id)
      .then(res => {
        setRenewalStatus(res.data.renewalStatus)
      })
      .catch(err => {
        console.error(err);
      });
  }

  const renderCancelButton = () => {

    if (renewalStatus) {

      if (renewalStatus.status != 'canceled') {
        return (
          <>
            <Flex w="12px" />
            <Button bg="#F32FE0" onClick={cancelSubscription}>Cancel</Button>
          </>
        )
      }

    }

  }

  const revokeLicense = () => {

    axios
      .put('/api/admin/licenses/revoke-license?id=' + licenseData.id + '&owner_discord_id=' + licenseData.owner_discord_id)
      .then(res => {
        if (res.status == 200) {
          location.reload();
        }
      })
      .catch(err => {
        console.error(err);
      });

  }

  const updateForceUnbind = (boolVal) => {

    axios
      .put('/api/admin/licenses/force-unbind?id=' + licenseData.id + '&force=' + (!licenseData.force_no_unbind))
      .then(res => {
        if (res.data.license) {
          setLicenseData(res.data.license);
        }
      })
      .catch(err => {
        console.error(err);
      });

  }

  const renderRevokeButton = () => {

    if (licenseData.owner_discord_id) {
      return (
        <>
          <Button bg={"#B440CF"} onClick={revokeLicense}>Revoke</Button>
          <Flex w="12px" />
        </>
      )
    }
  }

  const renderForceUnbindButton = () => {

    if (licenseData.Type.unbindable) {

      if (!licenseData.force_no_unbind) {

        return (
          <>
            <Button bg={"#FFB25C"} onClick={updateForceUnbind}>Disable Unbind</Button>
          </>
        )

      } else {

        return (
          <>
            <Button bg={"#60FFB0"} onClick={updateForceUnbind}>Enable Unbind</Button>
          </>
        )

      }

    }

  }

  const unbindLicense = () => {

    axios
      .put('/api/admin/licenses/unbind-license?id=' + licenseData.id)
      .then(res => {
        if (res.data.license) {
          setLicenseData(res.data.license);
        }
      })
      .catch(err => {
        console.error(err);
      });

  }

  const renderUnbindButton = () => {

    if (licenseData.User) {

      return (
        <>
          <Button bg={"#FF5071"} onClick={unbindLicense}>Unbind</Button>
        </>
      )

    }

  }

  const renderLicenseRenewal = () => {
    ReactTooltip.rebuild();

    return (
      <Flex w="15%">
        <StatusText>{renewalStatus ? renderLicenseStatus() : "N/A"}</StatusText>
      </Flex>
    )
  }

  return (
    <>
      <Container minw="600px">
        <Flex w="100%" onClick={() => openLicense()}>
          <Flex w="25%">
            <TruncateText>{licenseData.User ? licenseData.User.discord_id : "N/A"}</TruncateText>
          </Flex>
          <Flex w="25%">
            <TruncateText>{licenseData.Type.name}</TruncateText>
          </Flex>
          <Flex w="25%">
            <StatusText>{licenseData.Type.label}</StatusText>
          </Flex>
          {renderLicenseRenewal()}
          <Flex fg="1" />
          <Button bg="transparent" style={{ padding: 0, height: 12 }}>{isOpen ? "-" : "+"}</Button>
        </Flex>
        {isLoading &&
          <>
            <Spinner></Spinner>
          </>
        }

        {isOpen &&
          <>
            <Flex w="100%" style={{ marginTop: 18 }}>
              <Flex w="25%">
                <TruncateText>Access Key</TruncateText>
              </Flex>
              <Flex w="25%">
                <TruncateText>Expiration Date</TruncateText>
              </Flex>
              <Flex w="25%">
                <TruncateText>Member Since</TruncateText>
              </Flex>
            </Flex>
            <Flex w="100%" style={{ color: '#fff', marginTop: 18 }}>
              <Flex w="25%">
                <TruncateText>{licenseData.key}</TruncateText>
              </Flex>
              <Flex w="25%">
                <TruncateText>{licenseData.cancelsAt ? moment(licenseData.cancelsAt).format('MMMM D, YYYY') : "N/A"}</TruncateText>
              </Flex>
              <Flex w="25%">
                <TruncateText>{licenseData.User ? moment(licenseData.User.createdAt).format('MMMM D, YYYY') : "N/A"}</TruncateText>
              </Flex>
            </Flex>
            <Flex w="100%" style={{ marginTop: 18, flexWrap: 'wrap' }}>
              {renderUnbindButton()}
              <Flex w="12px" />
              {renderRevokeButton()}
              {renderForceUnbindButton()}
              {renderCancelButton()}
              <Flex w="12px" />
              <Button bg="#A4A1FF" onClick={displayDiscordInfo}>Discord Info</Button>
              <Flex w="12px" />
              <Button bg="#8A45FF" onClick={displayUserLogs}>User Logs</Button>
              <Flex w="12px" />
              <Button bg="#333757" onClick={displayLicenseLogs}>License Logs</Button>
            </Flex>
          </>
        }
        <NotificationContainer />
      </Container>
      {showModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">{modalHeader}</Text.Heading>
            <Flex h="24px" />
            <TextArea readonly onChange={(e) => e.preventDefault()}>{modalContent}</TextArea>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Flex fg={1} />
              <ModalButton onClick={hideModal} bg="#F32FE0">Exit</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }
    </>
  )
}

export default License;
